module.exports = __webpack_public_path__ + "static/media/user.09a8b59b.png";